import { IWithChildren } from 'types';
import styles from './styles.module.scss';

export const RegionSmallHeader = ({ title, children }:{ title: string } & IWithChildren) => (
  <div className={styles.box}>
    <h3>{title}</h3>
    <div>{children}</div>
  </div>
);
